import React from 'react';
export function Divider() {
  return <div className="w-full flex justify-center py-16" data-id="element-224">
      <div className="w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" data-id="element-225"></div>
    </div>;
}